// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"sociallinks-module--sr-only--1zHOc","srOnlyFocusable":"sociallinks-module--sr-only-focusable--2triT","social":"sociallinks-module--social--HPzyY"};